import { h } from "preact";
import { useState } from "preact/hooks";
import { Route, Routes, useNavigate } from "react-router-dom";

import AppFocusLayout from "../components/AppFocusLayout.jsx";
import Button from "../components/Button.jsx";
import Icon from "../components/Icon.jsx";
import ProjectViaLink from "../components/projectsAdd/ProjectViaLink.jsx";
import ProjectViaPdf from "../components/projectsAdd/ProjectViaPdf.jsx";
import ProjectWizard from "../components/projectsAdd/ProjectWizard.jsx";

import i18n from "../i18n.js";
import { getRouteQueryParams } from "../helpers.js";

function Selection() {
  const navigate = useNavigate();

  return (
    <div>
      <h1 class="t-h4 t-h4--margin-small">
        {i18n.t("pages.projects.add.title")}
      </h1>
      <p class="t-body2 color-shades-charcoal mb-48">
        {i18n.t("pages.projects.add.subtitle")}
      </p>

      <div class="products-add-page__choices">
        <div
          class="products-add-page__choice"
          role="button"
          onClick={() => navigate("/projects/add/wizard")}
        >
          <Icon class="mb-24" big>
            choice_add
          </Icon>
          <h4 class="t-subtitle2 t-subtitle2--margin-small">
            {i18n.t("pages.projects.add.wizard.title")}
          </h4>
          <p class="t-caption color-shades-charcoal">
            {i18n.t("pages.projects.add.wizard.description")}
          </p>
        </div>

        <div
          class="products-add-page__choice"
          role="button"
          onClick={() => navigate("/projects/add/pdf")}
        >
          <Icon class="mb-24" big>
            choice_pdf
          </Icon>
          <h4 class="t-subtitle2 t-subtitle2--margin-small">
            {i18n.t("pages.projects.add.pdf.title")}
          </h4>
          <p class="t-caption color-shades-charcoal">
            {i18n.t("pages.projects.add.pdf.description")}
          </p>
        </div>

        <div
          class="products-add-page__choice"
          role="button"
          onClick={() => navigate("/projects/add/link")}
        >
          <Icon class="mb-24" big>
            choice_link
          </Icon>
          <h4 class="t-subtitle2 t-subtitle2--margin-small">
            {i18n.t("pages.projects.add.link.title")}
          </h4>
          <p class="t-caption color-shades-charcoal">
            {i18n.t("pages.projects.add.link.description")}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function ProjectAddPage() {
  const queryParams = getRouteQueryParams(window.location.search);
  const navigate = useNavigate();

  return (
    <AppFocusLayout
      closerAction={
        <Button text to={queryParams.backTo || "/projects"}>
          <Icon>close</Icon>
        </Button>
      }
      title=""
    >
      <div class="row">
        <div class="col l8 push-l2">
          <Routes>
            <Route element={<Selection />} path="/" />
            <Route
              element={
                <ProjectWizard onBack={() => navigate("/projects/add")} />
              }
              path="/wizard"
            />
            <Route
              element={
                <ProjectViaPdf onBack={() => navigate("/projects/add")} />
              }
              path="/pdf"
            />
            <Route
              element={
                <ProjectViaLink onBack={() => navigate("/projects/add")} />
              }
              path="/link"
            />
          </Routes>
        </div>
      </div>
    </AppFocusLayout>
  );
}
